import React from 'react';
import HeaderTags from '../../common/headerTags/HeaderTags';
import About from '../../components/aboutUs/index';

const headerTags = {
    title: 'Sobre a Rádio - Há mais de cinco décadas no ar', // max 60 char in total, ' | Antena 1' (11 chars) is automatically added by the Headers Tag and is truncated
    meta: {
        description: 'Sempre apostando em novas tecnologias, a Antena 1 é sinônimo de inovação desde a sua criação. Conheça sobre a rádio online que á mais ouvida do Brasil!',
        keywords: 'descrição, história, informação, diferencial, emissora, fundação, tecnologia, inovação, satélite, antena 1 street view',
        'og:title': 'Sobre a Rádio - Há mais de cinco décadas no ar',
        'og:description': 'Sempre apostando em novas tecnologias, a Antena 1 é sinônimo de inovação desde a sua criação. Conheça sobre a rádio online que á mais ouvida do Brasil!',
    },
};

const QuemSomos = () => (
    <div className="pageWrapper tw-container tw-mx-auto tw-px-5">
        <HeaderTags title={headerTags.title} meta={headerTags.meta} />
        <About />
    </div>
);

export default QuemSomos;
